export const bodyFont = '"HeeboRegular", sans-serif';
export const boldFont = '"HeeboBold", sans-serif';
export const mediumFont = '"HeeboMedium", sans-serif';
export const lightFont = '"HeeboLight", sans-serif';
export const secondaryLightFont = '"NextExitFOTLight"';
